// 分譲メニューを表示するショップIDのリスト
export const SUBDIVISION_MENU_VISIBLE_SHOP_IDS = [
  1, // 株式会社３Films不動産 六本木店
  5, // 株式会社３Films 営業
  50724, // マイホーム池田店
  50725, // マイホーム川西店
]
